'use client';
import { Import, ImportRecap } from '@/containers';
import { NotifsContext } from '@/contexts';
import { useImportPdvsMutation } from '@/services/API';
import { APIMessage } from '@/types';
import { jsonToCsv } from '@/utils/files';
import { useContext, useState } from 'react';

export default function Page() {
  const { addToast } = useContext(NotifsContext);

  const [importPdvs, { isLoading: isImportLoading }] = useImportPdvsMutation();

  const [filesToDownload, setFilesToDownload] = useState<
    { content: string; fileName: string }[]
  >([]);
  const [importedFiles, setImportedFiles] = useState<boolean>(false);

  function onImport(file: FormData) {
    importPdvs(file)
      .unwrap()
      .then((response) => {
        const createdElements = response.resources.filter(
          (element) => element.message === APIMessage.OK
        );
        const formatedResult = response.resources.map(
          ({ message, bnppf_pos_id = '', description = '' }) => ({
            message,
            'Numéro agrément':bnppf_pos_id,
            description,
          })
        );
        setFilesToDownload([
          {
            content: jsonToCsv(formatedResult),
            fileName: 'all_result.csv',
          },
        ]);

        setImportedFiles(true);
        addToast &&
          addToast({
            toastType: 'success',
            children: `Confirmation de création de
                ${createdElements.length} / ${response.resources.length} éléments.`,
          });
      })
      .catch((response) => {
        let errorMsg = '';
        try {
          errorMsg = '(' + response.data[0].error_description + ')';
        } catch (error) {}
        addToast &&
          addToast({
            toastType: 'error',
            children:
              `Une erreur est survenue.
            Rééssayer ultérieurement ` + errorMsg,
          });
      });
  }

  return !importedFiles ? (
    <Import
      title={'2. Importer une liste de Numéros d’agrément'}
      modelLink={'/csv/ppid_import_pos_2.csv'}
      onImport={onImport}
      isImportLoading={isImportLoading}
    />
  ) : (
    <ImportRecap twoFiles={false} files={filesToDownload} />
  );
}
